/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AnalysisResultDtoAirPressureFault } from './AnalysisResultDtoAirPressureFault';
import {
    AnalysisResultDtoAirPressureFaultFromJSON,
    AnalysisResultDtoAirPressureFaultFromJSONTyped,
    AnalysisResultDtoAirPressureFaultToJSON,
} from './AnalysisResultDtoAirPressureFault';
import type { AnalysisResultDtoAreaFlatness } from './AnalysisResultDtoAreaFlatness';
import {
    AnalysisResultDtoAreaFlatnessFromJSON,
    AnalysisResultDtoAreaFlatnessFromJSONTyped,
    AnalysisResultDtoAreaFlatnessToJSON,
} from './AnalysisResultDtoAreaFlatness';
import type { ProfileAnalysisResultDtoCaxDeviation } from './ProfileAnalysisResultDtoCaxDeviation';
import {
    ProfileAnalysisResultDtoCaxDeviationFromJSON,
    ProfileAnalysisResultDtoCaxDeviationFromJSONTyped,
    ProfileAnalysisResultDtoCaxDeviationToJSON,
} from './ProfileAnalysisResultDtoCaxDeviation';

/**
 * 
 * @export
 * @interface ProfileAnalysisResultDto
 */
export interface ProfileAnalysisResultDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalysisResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalysisResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileAnalysisResultDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalysisResultDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    creatorUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    lastModifierUser?: string | null;
    /**
     * 
     * @type {ProfileAnalysisResultDtoCaxDeviation}
     * @memberof ProfileAnalysisResultDto
     */
    caxDeviation?: ProfileAnalysisResultDtoCaxDeviation | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    caxDeviationFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof ProfileAnalysisResultDto
     */
    flatness?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    flatnessFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {ProfileAnalysisResultDtoCaxDeviation}
     * @memberof ProfileAnalysisResultDto
     */
    radiationFieldSize?: ProfileAnalysisResultDtoCaxDeviation | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    radiationFieldSizeFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof ProfileAnalysisResultDto
     */
    stabilityIndex?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    stabilityIndexFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof ProfileAnalysisResultDto
     */
    symmetry?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    symmetryFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    $type?: ProfileAnalysisResultDtoTypeEnum;
}


/**
 * @export
 */
export const ProfileAnalysisResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAnalysisComponentDtoProfileAnalysisResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.AnalysisComponent.Dto.ProfileAnalysisResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ProfileAnalysisResultDtoTypeEnum = typeof ProfileAnalysisResultDtoTypeEnum[keyof typeof ProfileAnalysisResultDtoTypeEnum];


/**
 * Check if a given object implements the ProfileAnalysisResultDto interface.
 */
export function instanceOfProfileAnalysisResultDto(value?: unknown): value is ProfileAnalysisResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ProfileAnalysisResultDtoTypeEnum)[0];
}

export function ProfileAnalysisResultDtoFromJSON(json: any): ProfileAnalysisResultDto {
    return ProfileAnalysisResultDtoFromJSONTyped(json, false);
}

export function ProfileAnalysisResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileAnalysisResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : json['creatorUser'],
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : json['lastModifierUser'],
        'caxDeviation': !exists(json, 'caxDeviation') ? undefined : ProfileAnalysisResultDtoCaxDeviationFromJSON(json['caxDeviation']),
        'caxDeviationFault': !exists(json, 'caxDeviationFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['caxDeviationFault']),
        'flatness': !exists(json, 'flatness') ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['flatness']),
        'flatnessFault': !exists(json, 'flatnessFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['flatnessFault']),
        'radiationFieldSize': !exists(json, 'radiationFieldSize') ? undefined : ProfileAnalysisResultDtoCaxDeviationFromJSON(json['radiationFieldSize']),
        'radiationFieldSizeFault': !exists(json, 'radiationFieldSizeFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['radiationFieldSizeFault']),
        'stabilityIndex': !exists(json, 'stabilityIndex') ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['stabilityIndex']),
        'stabilityIndexFault': !exists(json, 'stabilityIndexFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['stabilityIndexFault']),
        'symmetry': !exists(json, 'symmetry') ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['symmetry']),
        'symmetryFault': !exists(json, 'symmetryFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['symmetryFault']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ProfileAnalysisResultDtoToJSON(value?: ProfileAnalysisResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'creatorUser': value.creatorUser,
        'lastModifierUser': value.lastModifierUser,
        'caxDeviation': ProfileAnalysisResultDtoCaxDeviationToJSON(value.caxDeviation),
        'caxDeviationFault': AnalysisResultDtoAirPressureFaultToJSON(value.caxDeviationFault),
        'flatness': AnalysisResultDtoAreaFlatnessToJSON(value.flatness),
        'flatnessFault': AnalysisResultDtoAirPressureFaultToJSON(value.flatnessFault),
        'radiationFieldSize': ProfileAnalysisResultDtoCaxDeviationToJSON(value.radiationFieldSize),
        'radiationFieldSizeFault': AnalysisResultDtoAirPressureFaultToJSON(value.radiationFieldSizeFault),
        'stabilityIndex': AnalysisResultDtoAreaFlatnessToJSON(value.stabilityIndex),
        'stabilityIndexFault': AnalysisResultDtoAirPressureFaultToJSON(value.stabilityIndexFault),
        'symmetry': AnalysisResultDtoAreaFlatnessToJSON(value.symmetry),
        'symmetryFault': AnalysisResultDtoAirPressureFaultToJSON(value.symmetryFault),
        '$type': value.$type,
    });
}

